<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header">
          <div class="dialog-header-content">
            <div class="dialog-title-wrapper">
              <div class="dialog-icon">
                <icon name="global-icon" />
              </div>

              <div class="dialog-text">
                <div class="dialog-title">
                  Office Performance Commitment and Review (OPCR)
                </div>

                <div class="dialog-subtitle">
                  Manage and monitor monthly accomplishments, outputs, and
                  performance results.
                </div>
              </div>
            </div>

            <v-btn icon class="close-btn" @click="closeD()">
              <icon name="circle-close" />
            </v-btn>
          </div>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-col cols="8" class="flex-items mt-2">
            <v-tabs v-model="activeTab" color="#519043" align-tabs="left">
              <v-tab
                v-for="tab in tabList"
                :key="tab.id"
                @change="changeTab(tab)"
                >{{ tab.name }}</v-tab
              >
            </v-tabs>
          </v-col>
          <v-spacer></v-spacer>

          <v-card class="dt-container" elevation="0" outlined>
            <v-data-table
              :headers="
                tab == 1 ? cf_headers : tab == 2 ? sp_headers : support_headers
              "
              :loading="tbl_loading"
              :items="dataItem"
              :items-per-page="10"
            >
              <template v-slot:[`item.code`]="{ item }">
                <span v-if="item.sp_type == 'pap'" class="text-center">
                  {{
                    item.suc_code
                      ? item.code + " /" + item.suc_code + ""
                      : item.code
                  }}</span
                >
                <span v-else class="text-center">
                  {{
                    item.pap_code
                      ? item.code + " /" + item.pap_code + ""
                      : item.code
                  }}</span
                >
              </template>
              <template v-slot:[`item.eqt`]="{ item }">
                <div class="d-flex align-center justify-space-between">
                  <div class="text-caption">E</div>
                  <div class="align-self-center">
                    <v-icon v-if="item.eff_is_rated" color="#519043"
                      >mdi-check</v-icon
                    >
                    <v-chip v-if="!item.eff_is_rated" x-small>NR</v-chip>
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between">
                  <div class="text-caption">Q</div>
                  <div class="align-self-center">
                    <v-icon v-if="item.qly_is_rated" color="#519043"
                      >mdi-check</v-icon
                    >
                    <v-chip v-if="!item.qly_is_rated" x-small>NR</v-chip>
                  </div>
                </div>
                <div class="d-flex align-center justify-space-between">
                  <div class="text-caption">T</div>

                  <div class="align-self-center">
                    <v-icon v-if="item.timeliness_is_rated" color="#519043"
                      >mdi-check</v-icon
                    >
                    <v-chip v-if="!item.timeliness_is_rated" x-small>NR</v-chip>
                  </div>
                </div>
              </template>

              <template v-slot:[`item.alloted_budget`]="{ item }">
                {{
                  item.alloted_budget ? formatPrice(item.alloted_budget) : ""
                }}
              </template>

              <template v-slot:[`item.isDistributed`]="{ item }">
                <v-chip
                  x-small
                  class="white--text"
                  :color="item.isDistributed ? '#519043' : 'warning'"
                >
                  {{ item.isDistributed ? "Yes" : "No" }}
                </v-chip>
              </template>
              <template v-slot:[`item.action`]="{ item }" v-if="toPending">
                <div class="button-group pa-2">
                  <v-btn
                    v-if="item.pendingRemarks.length > 0"
                    class="global-btn-save"
                    @click="viewItem(item)"
                  >
                    View Remarks
                  </v-btn>
                  <v-btn
                    class="global-btn-save"
                    @click="pendingItem(item)"
                    v-if="item.sp_type != 'suc_lvl'"
                  >
                    Add Pending Remarks
                  </v-btn>
                </div>
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-card-text class="pa-1 mt-8 d-flex justify-end">
            <v-btn
              class="btn-pending mr-3"
              outlined
              @click="setToPending()"
              v-if="!toPending"
              v-show="tbl_tab == 1"
            >
              Pending
            </v-btn>

            <v-btn
              @click="approve()"
              class="btn-save"
              v-if="!toPending"
              v-show="tbl_tab == 1"
            >
              Approve
            </v-btn>
            <v-btn
              class="btn-cancel mr-3"
              :disabled="confirmLoading"
              v-if="toPending"
              @click="cancelPending()"
            >
              Cancel
            </v-btn>
            <v-btn
              v-if="toPending && pendingList.length > 0"
              class="btn-save"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmSavePending()"
            >
              Save
            </v-btn>
            <v-btn
              v-if="toPending && pendingList.length == 0"
              class="btn-pending"
              style="width: 160px"
              :disabled="confirmLoading"
              :loading="confirmLoading"
              @click="confirmPending()"
            >
              Submit For Pending
            </v-btn>
          </v-card-text>
          <!-- <v-spacer></v-spacer> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-bottom-sheet v-model="bottom_actions" v-if="tbl_tab == 1">
      <v-card class="text-center" height="120"> </v-card>
    </v-bottom-sheet>

    <v-dialog
      v-model="confirmSubmitDialog"
      persistent
      max-width="420"
      content-class="delete-dialog-content"
    >
      <v-card class="delete-dialog">
        <div class="delete-content">
          <div class="submit-icon">
            <icon name="circle-check" />
          </div>

          <div class="delete-title">Submit for Approval?</div>

          <div class="delete-description">
            <div class="text-body-1 mb-1" v-html="approvalHTML"></div>
          </div>
        </div>

        <v-divider />

        <v-card-actions class="pa-4">
          <v-btn
            text
            color="grey darken-1"
            class="btn-cancel"
            :disabled="confirmBtnLoading"
            @click="cancelConfirm()"
          >
            Cancel
          </v-btn>

          <v-spacer />

          <v-btn
            color="#147452"
            depressed
            class="btn-save"
            :loading="confirmBtnLoading"
            :disabled="confirmBtnLoading"
            @click="confirmSubmit()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- heads users dialog-->
    <v-dialog
      v-model="showPendingRemarksDialog"
      eager
      persistent
      scrollable
      max-width="700px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Pending Remarksss </span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="showPendingRemarksDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="max-height: 700px" class="my-4">
          <v-form ref="PendingRemarksRef" @submit.prevent>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-textarea
                    v-model="remarks"
                    dense
                    label="Remarks"
                    outlined
                    rows="5"
                    cols="10"
                    class="rounded-lg"
                    color="#93CB5B"
                  >
                  </v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="showPendingRemarksDialog = false">
            <v-icon>mdi-close-circle-outline</v-icon>
            Cancel
          </v-btn>
          <v-btn
            color="#519043"
            class="white--text"
            :loading="saveBtnLoading"
            :disabled="saveBtnLoading"
            @click="saveRemarks()"
          >
            <v-icon>mdi-check-circle</v-icon>
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <RemarksDialog
      :data="itemToPending"
      v-on:saveRemarks="saveRemarks"
      v-on:closeRemarks="closeRemarks"
      :type="type"
      :moduleFrom="'OPCR_TARGET_APPROVAL'"
    />

    <ViewRemarksTimelineDialog
      :data="list"
      v-on:closeRemarksTimeline="closeRemarksTimeline"
    />
    <WarningDialog :msg="cancelMsg" v-on:yes="yes" v-on:no="no" />

    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
import RemarksDialog from "../../Views/RemarksDialog.vue";
import ViewRemarksTimelineDialog from "../../Views/ViewRemarksTimelineDialog.vue";
import WarningDialog from "../../Views/WarningDialog.vue";
import icon from "@/assets/icon.vue";
export default {
  components: { icon, RemarksDialog, ViewRemarksTimelineDialog, WarningDialog },
  props: {
    data: null,
    tbl_tab: null,
  },
  data() {
    return {
      bottom_actions: false,
      toPending: false,
      cancelMsg: null,
      pendingList: [],
      itemToPending: null,
      confirmLoading: false,
      submitAction: null,
      type: null,
      list: [],
      remarksData: [],
      taggingDialog: false,
      tbl_loading: false,
      approvalHTML: null,
      approval: null,
      showPendingRemarksDialog: false,
      remarks: null,
      taggingBtnLoading: false,
      confirmBtnLoading: false,
      confirmSubmitDialog: false,
      confirmDialog: false,
      itemToDelete: null,
      assesed_by_status: null,
      options: {},
      action: null,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      mporData: [],
      dialog: false,
      activeTab: { id: 1, name: "Core Functions" },
      tab: 1,
      tabList: [
        { id: 1, name: "Core Functions" },
        { id: 2, name: "Strategic Priority" },
        { id: 3, name: "Support Functions" },
      ],
      opcrData: null,
      opcrSupData: null,
      isSubmitted: null,
      targetRating: null,
      isSubmitLoading: false,
      assessed_by: null,
      assessed_by_status: null,
      final_rating_by: null,
      final_rating_by_status: null,
      id: null,
      ipcrSupport: null,
      dataItem: [],
      expanded: [],
      isButtonLoading: false,
      tagged_head_data: [],
      head_target: null,
      tagged_head_headers: [
        {
          text: "Name",
          value: "head_user.name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Office",
          value: "head_user.office",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Targets",
          value: "target",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 200,
        },
      ],
      cf_headers: [
        {
          text: "Major Final Output",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Is A Tagged Target",
        //   value: "is_tagged",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },

        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ],
      sp_headers: [
        {
          text: "Code",
          value: "code",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Major Final Output",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Is Distributed",
        //   value: "isDistributed",
        //   align: "center",
        //   valign: "center",
        //   sortable: false,
        // },
        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ],

      linked_headers: [
        {
          text: "Employee",
          value: "name",
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          valign: "center",
          sortable: false,
        },
      ],
      support_headers: [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   align: "end",
        // },
      ],
      itemForTagging: null,
      tagIdxToUpdate: null,
      target_to_distribute: null,
      tempHeadsList: [],
      taggingType: null,
      tagHeadAction: null,
      headsDialog: false,
      tagged_head_temp_data: null,
      saveBtnLoading: false,
      unTagUser: null,
      unTagDialog: false,
      untagList: [],
      sdp_target_format: null,
      myTaggingType: null,
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("APPROVAL", data);

        this.id = data.id;
        this.activeTab = { id: 1, name: "Core Functions" };
        this.tab = 1;
        this.initialize();
        // this.getHeadUsers();
        // this.getMyTaggingType();
      },
      deep: true,
    },
    shouldPreventRefresh: {
      deep: true,
      handler(shouldPrevent) {
        if (shouldPrevent) {
          window.addEventListener("beforeunload", this.handleBeforeUnload);
        } else {
          window.removeEventListener("beforeunload", this.handleBeforeUnload);
        }
      },
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {},
  computed: {
    shouldPreventRefresh() {
      return this.pendingList.length > 0;
    },
    getCurrentTaggedTotal() {
      let total = 0;
      for (let i = 0; i < this.tagged_head_data.length; i++) {
        total += parseInt(this.tagged_head_data[i].target);
      }
      return total;
    },

    getPositionToTag() {
      let toTag = "";
      let label = "";
      let canTag = true;
      if (this.myTaggingType && this.myTaggingType.type == "vp") {
        label = "Tag to";
        if (this.myTaggingType.office_type != "academic affairs") {
          toTag = "Directors";
        } else {
          toTag = "Deans/Directors";
        }
      } else if (this.myTaggingType && this.myTaggingType.type == "director") {
        label = "Tag to";
        toTag = "Unit Heads";
      } else if (this.myTaggingType && this.myTaggingType.type == "dean") {
        canTag = false;
        label = "Tag to";
        toTag = "Program Chairpersons";
      } else if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        label = "Tag to";
        toTag = "Personnel/s";
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        canTag = false;
        label = "Tag to";
        toTag = "Faculty/Faculties";
      }
      return {
        label,
        toTag,
        canTag,
      };
    },
    isTargetNeedForTagging() {
      let needed = true;

      if (this.myTaggingType && this.myTaggingType.type == "unit_head") {
        needed = false;
      } else if (
        this.myTaggingType &&
        this.myTaggingType.type == "prog_chair"
      ) {
        needed = false;
      }
      return needed;
    },
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);

    this.eventHub.$off("closeAddOPCRTargetsDialog");
    this.eventHub.$off("closeUpdateOPCRSupportFunctionDialog");
  },

  methods: {
    handleBeforeUnload(e) {
      this.removePendingRemarks();
      e.preventDefault();
      e.returnValue = "";
      return "";
    },
    initialize() {
      this.tbl_loading = true;
      this.loadRemarks(this.data.id);

      this.axiosCall(
        "/opcr-target/getOPCRTargetForApprovalBy/" +
          this.data.opcrID +
          "/" +
          this.tab,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("Init", res.data);
          if (!this.toPending || this.tab != 3) {
            this.dataItem = res.data;
          } else {
            this.dataItem = [];
          }
          this.tbl_loading = false;
        }
      });
    },

    loadRemarks(id) {
      if (id) {
        this.axiosCall("/remarks/" + id + "/OPCR_TARGET_APPROVAL ", "GET").then(
          (res) => {
            if (res.data) {
              console.log("remarks", res.data);
              this.remarksData = res.data;
            }
          },
        );
      }
    },

    closeD() {
      if (this.shouldPreventRefresh) {
        this.fadeAwayMessage.show = true;
        this.fadeAwayMessage.type = "error";
        this.fadeAwayMessage.header = "System Message";
        this.fadeAwayMessage.timeout = 5000;
        this.fadeAwayMessage.message =
          "You have unsaved changes, please click the ACTIONS button below to show save button.";
      } else {
        this.confirmSubmitDialog = false;
        this.confirmBtnLoading = false;
        this.bottom_actions = false;
        this.toPending = false;
        this.cancelMsg = null;
        this.isSubmitLoading = false;
        this.eventHub.$emit("closeOPCRTargetApprovalDialog", false);
        this.dialog = false;
      }
    },
    closeRemarks(data) {
      this.itemToDelete = data;
    },
    closeRemarksTimeline() {
      this.list = [];
    },
    setHeaders() {
      let cf_headers = [
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ];
      let cf_headers_action = [
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ];
      let sp_headers = [
        {
          text: "Code",
          value: "code",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        // {
        //   text: "Action",
        //   value: "action",
        //   width: 150,
        //   align: "end",
        // },
      ];
      let sp_headers_action = [
        {
          text: "Code",
          value: "code",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "MFO",
          value: "mfo",
          width: 300,
          align: "start",
          valign: "start",
          sortable: false,
        },
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          width: 300,
          valign: "center",
          sortable: false,
        },
        {
          text: "Alloted Budget",
          value: "alloted_budget",
          align: "center",
          valign: "center",
          sortable: false,
        },

        {
          text: "Action",
          value: "action",
          width: 150,
          align: "end",
        },
      ];

      let support_headers = [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        // {
        //   text: "Action",
        //   value: "action",
        //   align: "end",
        // },
      ];
      let support_headers_action = [
        {
          text: "Success Indicator",
          value: "success_indicator",
          align: "start",
          sortable: false,
        },
        {
          text: "Actual Accomplishment",
          value: "actual_accom",
          align: "center",

          valign: "center",
          sortable: false,
        },

        {
          text: "To be Rated",
          value: "eqt",
          align: "center",
          valign: "center",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          align: "end",
        },
      ];

      this.cf_headers = this.toPending ? cf_headers_action : cf_headers;
      this.sp_headers = this.toPending ? sp_headers_action : sp_headers;
      this.support_headers = this.toPending
        ? support_headers_action
        : support_headers;
    },
    setToPending() {
      this.toPending = true;
      this.bottom_actions = false;
      this.setHeaders();
    },
    saveRemarks(data) {
      this.setHeaders();
      this.initialize();
      this.pendingList.push(data);
      this.initialize();
    },

    removePendingRemarks() {
      if (this.pendingList.length > 0) {
        let data = {
          list: JSON.stringify(this.pendingList),
        };
        this.axiosCall("/remarks/remove-pending-remarks", "POST", data).then(
          (res) => {
            if (res.data.status == 200) {
              this.cancelMsg = null;
              this.toPending = false;
              this.pendingList = [];
              this.setHeaders();
              this.initialize();
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "success";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = "Pending Cancelled!";
              // this.closeD();
            } else if (res.data.status == 400) {
              this.cancelMsg = null;
              this.fadeAwayMessage.show = true;
              this.fadeAwayMessage.type = "error";
              this.fadeAwayMessage.header = "System Message";
              this.fadeAwayMessage.message = res.data.msg;
            }
          },
        );
      } else {
        this.toPending = false;
        this.cancelMsg = null;
        this.setHeaders();
        this.initialize();
      }
    },

    viewItem(item) {
      this.list = [];
      setTimeout(() => {
        this.list = item.pendingRemarks;
      }, 100);
    },

    pendingItem(item) {
      this.type =
        this.tab == 1
          ? "Core Function"
          : this.tab == 2
          ? "Strategic Priority"
          : "Support Function";
      this.itemToPending = null;
      setTimeout(() => {
        if (this.tab == 2) {
          this.itemToPending = {
            id: item.OpcrPapTargetDistributedTaggingID,
          };
        } else {
          this.itemToPending = item;
        }
      }, 100);
      console.log("PENDING", item);
    },

    // pending() {
    //   this.approval = "pending";
    //   this.approvalHTML =
    //     "<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>PENDING</b> this OPCR Targets?</div>";
    //   this.confirmSubmitDialog = true;
    // },
    approve() {
      this.approval = "approve";
      this.approvalHTML =
        "<div>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Are you sure you want to <b>APPROVE</b> this OPCR Targets?</div>";
      this.confirmSubmitDialog = true;
    },

    confirmPending() {
      this.submitAction = "confirm pending";
      this.cancelMsg =
        "Are you sure you want to submit this for PENDING? Please note that this action is irreversible.";
    },

    cancelPending() {
      this.submitAction = "cancel pending";
      if (this.pendingList.length > 0) {
        this.cancelMsg =
          "You have added pending remarks! Are you sure you want to CANCEL the Pending? Added remarks will not be saved.";
      } else {
        this.removePendingRemarks();
      }
    },

    confirmSavePending() {
      this.confirmBtnLoading = false;
      this.pendingList = [];
      this.fadeAwayMessage.show = true;
      this.fadeAwayMessage.type = "success";
      this.fadeAwayMessage.header = "System Message";
      this.fadeAwayMessage.message = "Saved successfully!";
    },

    submitForPending() {
      let data = {
        id: this.id,
        approval: "pending",
        remarks: null,
      };

      this.axiosCall("/opcr-target/submitTargetsApproval", "POST", data).then(
        (res) => {
          if (res.data.status == 201) {
            this.cancelMsg = null;

            this.confirmLoading = false;
            this.pendingList = [];
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;

            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    yes() {
      if (this.submitAction == "cancel pending") {
        this.removePendingRemarks();
      }
      if (this.submitAction == "confirm pending") {
        this.submitForPending();
      }
      if (this.submitAction == "approve") {
        this.showApprovalRemarks();
      }
    },
    no() {
      this.submitAction = null;
      this.cancelMsg = null;
    },

    // getMyFilteredUserList() {
    //   let filtered = [];
    //   let off = this.$store.state.emp.officeID;
    //   // console.log(
    //   //   "OFF",
    //   //   off,
    //   //   this.myTaggingType.office_type,
    //   //   this.myTaggingType.type
    //   // );
    //   if (this.myTaggingType && this.myTaggingType.type == "vp") {
    //     for (let i = 0; i < this.usersList.length; i++) {
    //       if (this.myTaggingType.office_type != "academic affairs") {
    //         if (
    //           this.usersList[i].office_underID == off &&
    //           this.usersList[i].roleID == 7
    //         ) {
    //           filtered.push(this.usersList[i]);
    //         }
    //       } else {
    //         if (
    //           this.usersList[i].office_underID == off &&
    //           (this.usersList[i].roleID == 7 || this.usersList[i].roleID == 8)
    //         ) {
    //           filtered.push(this.usersList[i]);
    //         }
    //       }
    //     }
    //   } else if (this.myTaggingType.type == "director") {
    //     for (let i = 0; i < this.usersList.length; i++) {
    //       if (this.myTaggingType.office_type == "admin and finance") {
    //         if (
    //           this.usersList[i].office_underID == off &&
    //           (this.usersList[i].roleID == 9 || this.usersList[i].roleID == 1)
    //         ) {
    //           filtered.push(this.usersList[i]);
    //         }
    //       } else {
    //         if (
    //           this.usersList[i].office_underID == off &&
    //           this.usersList[i].roleID == 9
    //         ) {
    //           filtered.push(this.usersList[i]);
    //         }
    //       }
    //     }
    //   } else if (this.myTaggingType.type == "dean") {
    //     for (let i = 0; i < this.usersList.length; i++) {
    //       if (
    //         (this.usersList[i].office_underID == off ||
    //           this.usersList[i].officeID == off) &&
    //         this.usersList[i].roleID == 12
    //       ) {
    //         filtered.push(this.usersList[i]);
    //       }
    //     }
    //   } else if (
    //     this.myTaggingType.type == "unit_head" ||
    //     this.myTaggingType.type == "prog_chair"
    //   ) {
    //     for (let i = 0; i < this.usersList.length; i++) {
    //       if (
    //         (this.usersList[i].office_underID == off ||
    //           this.usersList[i].officeID == off) &&
    //         this.usersList[i].roleID == 2
    //       ) {
    //         filtered.push(this.usersList[i]);
    //       }
    //     }
    //   }

    //   return filtered;
    // },

    // tag(item) {
    //   this.itemForTagging = item;
    //   this.taggingType = item.taggingType;
    //   console.log(this.myTaggingType.type, item);
    //   if (
    //     // this.myTaggingType.type == "prog_chair" ||
    //     this.myTaggingType.type == "unit_head"
    //   ) {
    //     this.axiosCall(
    //       "/opcr-target/getTaggedPersonnel/" +
    //         item.OpcrPapTargetDistributedTaggingID +
    //         "/" +
    //         this.myTaggingType.type +
    //         "/sp",
    //       "GET"
    //     ).then((res) => {
    //       let data = res.data;
    //       console.log("asdasd", res.data);
    //       for (let i = 0; i < data.length; i++) {
    //         data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
    //       }
    //       this.tagged_head_data = data;
    //     });

    //     this.taggingDialog = true;
    //   } else {
    //     this.sdp_target_format = item.sdp_target_format;

    //     if (this.myTaggingType.type != "vp") {
    //       this.target_to_distribute =
    //         item.sdp_target_format == "numeric"
    //           ? item.tagged_target
    //           : item.tagged_target + "%";
    //     } else {
    //       this.target_to_distribute =
    //         item.sdp_target_format == "numeric"
    //           ? item.target
    //           : item.target + "%";
    //     }
    //     this.tagged_head_data = [];
    //     this.taggingDialog = true;

    //     this.axiosCall(
    //       "/opcr-target/getTaggedOffices/" +
    //         item.id +
    //         "/" +
    //         this.myTaggingType.type +
    //         "/sp",
    //       "GET"
    //     ).then((res) => {
    //       let data = res.data;
    //       for (let i = 0; i < data.length; i++) {
    //         data[i].head_user.name = this.toTitleCase(data[i].head_user.name);
    //       }
    //       this.tagged_head_data = data;
    //     });
    //   }
    // },

    // add_head_tagging() {
    //   this.tagHeadAction = "Add";

    //   if (this.tagged_head_data.length > 0) {
    //     let list = this.getMyFilteredUserList();
    //     for (let i = 0; i < this.tagged_head_data.length; i++) {
    //       for (let j = 0; j < list.length; j++) {
    //         if (this.tagged_head_data[i].head_user.usID == list[j].usID) {
    //           list.splice(j, 1);
    //           break;
    //         }
    //       }
    //     }
    //     this.tempHeadsList = list;
    //   } else {
    //     this.tempHeadsList = this.getMyFilteredUserList();
    //   }

    //   console.log("tagging list", this.tempHeadsList);
    //   this.tagged_head_temp_data = null;
    //   this.head_target = null;
    //   this.headsDialog = true;
    // },

    // removeTaggedOnClick(item) {
    //   this.tagged_head_temp_data = null;
    //   console.log("REMOVED ON LCIK", item);
    //   for (let i = 0; i < this.tagged_head_data.length; i++) {
    //     if (this.tagged_head_data[i].head_user.usID == item.head_user.usID) {
    //       if (!item.opcrPapTargetDistributedTaggingID) {
    //         this.tagged_head_data.splice(i, 1);
    //       } else {
    //         this.untagList.push(this.tagged_head_data[i]);
    //         this.tagged_head_data.splice(i, 1);
    //       }
    //     }
    //   }
    // },

    // edit_tag(item, index) {
    //   // this.getHeadUsers();
    //   console.log(item, index);

    //   // console.log("TEMPHEAD", tempTaggedHeads);
    //   // setTimeout(() => {
    //   let tempTaggedHeads = [];
    //   for (let i = 0; i < this.tagged_head_data.length; i++) {
    //     if (this.tagged_head_data[i].head_user.usID != item.head_user.usID) {
    //       tempTaggedHeads.push(this.tagged_head_data[i]);
    //     }
    //   }

    //   this.tagIdxToUpdate = index;
    //   this.tagHeadAction = "Update";

    //   if (tempTaggedHeads.length > 0) {
    //     let list = this.getMyFilteredUserList();
    //     for (let i = 0; i < tempTaggedHeads.length; i++) {
    //       for (let j = 0; j < list.length; j++) {
    //         if (tempTaggedHeads[i].head_user.usID == list[j].usID) {
    //           list.splice(j, 1);
    //           break;
    //         }
    //       }
    //     }
    //     this.tempHeadsList = list;
    //   }
    //   // else {
    //   // this.tempHeadsList = this.getFilteredUserList;
    //   // }
    //   this.head_target = item.target;
    //   if (typeof item.head_user.usID == "number") {
    //     this.tagged_head_temp_data = item.head_user.usID.toString();
    //   } else {
    //     this.tagged_head_temp_data = item.head_user.usID;
    //   }

    //   this.headsDialog = true;
    //   // }, 100);
    // },

    // untag(item) {
    //   this.unTagUser = item;
    //   this.unTagDialog = true;
    // },

    // confirmUntag() {
    //   // console.log(this.unTagUser);
    //   this.removeTaggedOnClick(this.unTagUser);
    //   this.unTagUser = null;
    //   this.unTagDialog = false;
    // },
    // cancelUntag() {
    //   this.unTagUser = null;
    //   this.unTagDialog = false;
    // },

    // closeHeadsDialog() {
    //   this.tagHeadAction = null;
    //   this.headsDialog = false;
    // },

    // saveTaggedHeads() {
    //   if (this.isTargetNeedForTagging) {
    //     let todistribute;
    //     let target_to_distribute = this.target_to_distribute.toString();

    //     if (target_to_distribute.includes("%")) {
    //       todistribute = this.target_to_distribute.slice(0, -1);
    //     } else {
    //       todistribute = this.target_to_distribute;
    //     }
    //     if (this.getCurrentTaggedTotal <= todistribute) {
    //       let tempT =
    //         parseInt(this.getCurrentTaggedTotal) + parseInt(this.head_target);
    //       if (tempT <= todistribute) {
    //         for (let j = 0; j < this.usersList.length; j++) {
    //           if (this.tagged_head_temp_data == this.usersList[j].usID) {
    //             this.tagged_head_data.push({
    //               head_user: this.usersList[j],
    //               target: this.head_target,
    //             });
    //             break;
    //           }
    //         }
    //       } else {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message =
    //           "Total tagged targets exceeded the target to distribute!";
    //       }
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message =
    //         "Total tagged targets exceeded the target to distribute!";
    //     }
    //   } else {
    //     for (let j = 0; j < this.usersList.length; j++) {
    //       if (this.tagged_head_temp_data == this.usersList[j].usID) {
    //         this.tagged_head_data.push({
    //           head_user: this.usersList[j],
    //           target: null,
    //         });
    //         break;
    //       }
    //     }
    //   }

    //   this.closeHeadsDialog();
    // },

    // updateTaggedHeads() {
    //   for (let j = 0; j < this.usersList.length; j++) {
    //     if (this.tagged_head_temp_data == this.usersList[j].usID) {
    //       this.tagged_head_data[this.tagIdxToUpdate].head_user = this.usersList[
    //         j
    //       ];
    //       this.tagged_head_data[this.tagIdxToUpdate].target = this.head_target;
    //       break;
    //     }
    //   }
    //   this.tagIdxToUpdate = null;
    //   this.closeHeadsDialog();
    // },

    // saveTagging() {
    //   if (this.isTargetNeedForTagging) {
    //     let todistribute;
    //     let target_to_distribute = this.target_to_distribute.toString();
    //     if (target_to_distribute.includes("%")) {
    //       todistribute = this.target_to_distribute.slice(0, -1);
    //     } else {
    //       todistribute = this.target_to_distribute;
    //     }

    //     if (this.getCurrentTaggedTotal == parseInt(todistribute)) {
    //       this.taggingBtnLoading == true;
    //       let data = {
    //         taggingType: this.taggingType,
    //         opcrPapTargetDistributedTaggingID: this.itemForTagging
    //           .OpcrPapTargetDistributedTaggingID
    //           ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
    //           : null,
    //         idToTag: this.itemForTagging.id,
    //         tagged_head_data: JSON.stringify(this.tagged_head_data),
    //         untagList: JSON.stringify(this.untagList),
    //       };
    //       console.log(data);

    //       this.axiosCall("/opcr-target/save-sp-tagging", "POST", data).then(
    //         (res) => {
    //           if (res.data.status == 201) {
    //             this.taggingDialog = false;
    //             this.taggingBtnLoading = false;
    //             this.itemForTagging = null;
    //             this.tagged_head_data = [];
    //             this.fadeAwayMessage.show = true;
    //             this.fadeAwayMessage.type = "success";
    //             this.fadeAwayMessage.header = "System Message";
    //             this.fadeAwayMessage.message = res.data.msg;
    //           } else {
    //             this.fadeAwayMessage.show = true;
    //             this.fadeAwayMessage.type = "error";
    //             this.fadeAwayMessage.header = "System Message";
    //             this.fadeAwayMessage.message = res.data.msg;
    //             this.taggingBtnLoading = false;
    //           }
    //         }
    //       );
    //     } else {
    //       if (this.getCurrentTaggedTotal > parseInt(todistribute)) {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message =
    //           " Total tagged targets exceeded the target to distribute!";
    //       } else {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message =
    //           "Please tag director/heads accordingly!";
    //       }
    //     }
    //   } else {
    //     this.taggingBtnLoading == true;
    //     let data = {
    //       taggingType: this.taggingType,
    //       opcrPapTargetDistributedTaggingID: this.itemForTagging
    //         .OpcrPapTargetDistributedTaggingID
    //         ? this.itemForTagging.OpcrPapTargetDistributedTaggingID
    //         : null,
    //       idToTag: this.itemForTagging.id,
    //       tagged_head_data: JSON.stringify(this.tagged_head_data),
    //       typeOfTarget: "sp",
    //       untagList: JSON.stringify(this.untagList),
    //     };

    //     this.axiosCall(
    //       "/opcr-target/save-opcr-to-ipcr-tagging",
    //       "POST",
    //       data
    //     ).then((res) => {
    //       if (res.data.status == 201) {
    //         this.taggingDialog = false;
    //         this.taggingBtnLoading = false;
    //         this.itemForTagging = null;
    //         this.tagged_head_data = [];
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "success";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;
    //       } else {
    //         this.fadeAwayMessage.show = true;
    //         this.fadeAwayMessage.type = "error";
    //         this.fadeAwayMessage.header = "System Message";
    //         this.fadeAwayMessage.message = res.data.msg;
    //         this.taggingBtnLoading = false;
    //       }
    //     });
    //   }
    // },

    // submitTarget() {
    //   this.confirmSubmitDialog = true;
    // },

    confirmSubmit() {
      this.confirmBtnLoading = true;
      if (this.approval == "approve") {
        this.proceedApproval();
      }
      if (this.approval == "pending") {
        this.confirmSubmitDialog = false;
        this.showPendingRemarksDialog = true;
      }
    },

    cancelConfirm() {
      this.confirmSubmitDialog = false;
    },

    // saveRemarks() {
    //   this.saveBtnLoading = true;
    //   this.proceedApproval();
    // },

    proceedApproval() {
      let data;
      if (this.approval == "approve") {
        data = {
          id: this.id,
          approval: "approved",
        };
      }
      if (this.approval == "pending") {
        data = {
          id: this.id,
          approval: "pending",
          remarks: this.remarks,
        };
      }
      this.axiosCall("/opcr-target/submitTargetsApproval", "POST", data).then(
        (res) => {
          if (res.data.status == 201) {
            this.showPendingRemarksDialog = false;
            this.saveBtnLoading = false;
            this.confirmBtnLoading = false;
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
            this.remarks = null;
            this.approval = null;
            this.closeD();
          } else if (res.data.status == 400) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.header = "System Message";
            this.fadeAwayMessage.message = res.data.msg;
          }
        },
      );
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    // confirmDelete() {
    //   this.isButtonLoading = true;
    //   this.axiosCall(
    //     "/ipcr-target/deleteTarget/" + this.itemToDelete.id,
    //     "DELETE"
    //   ).then((res) => {
    //     if (res.data.status == 200) {
    //       this.confirmDialog = false;
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "success";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //       this.itemToDelete = null;
    //       this.confirmDialog = false;

    //       this.initialize();
    //     } else {
    //       this.fadeAwayMessage.show = true;
    //       this.fadeAwayMessage.type = "error";
    //       this.fadeAwayMessage.header = "System Message";
    //       this.fadeAwayMessage.message = res.data.msg;
    //       this.isButtonLoading = false;
    //     }
    //   });
    // },

    getHeadUsers() {
      this.axiosCall(
        "/user-details/getUsersHeadProgChairAbove_Office",
        "GET",
      ).then((res) => {
        let data = res.data;
        data.forEach((element, i) => {
          data[i].name = this.toTitleCase(element.name);
        });
        this.usersList = data;
        // console.log("USERS", res.data);
      });
    },

    getMyTaggingType() {
      this.axiosCall("/opcr-target/getMyTaggingType", "GET").then((res) => {
        this.myTaggingType = res.data;
      });
    },
  },
};
</script>
<style scoped></style>
